import './screen.css';

export const Screen = () => {

    return(
        <div id='reader' className="screen">
           
        </div>
    )
}